import { useMutation } from "@apollo/client";
import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { DELETE_ONE_PROMOTION } from "../../../apollo/mutations";
import { ReactComponent as DeleteIcon } from "../../../images/ic-delete.svg";
import { DELETE_BUTTON, Loading } from "../../UI";

export const DeletePromotion = ({ promotionId, text }) => {
  // local set

  let history = useHistory();

  const [deletePromotion, { loading }] = useMutation(DELETE_ONE_PROMOTION, {
    onCompleted(data) {
      history.push(`/promotions`);
    },
  });

  const handleDelete = () => {
    deletePromotion({
      variables: {
        where: { id: promotionId },
      },
    });
  };

  if (loading) return <Loading />;

  // render

  if (!text) {
    return <DeleteIcon onClick={handleDelete} />;
  }
  return (
    <DELETE_BUTTON onClick={() => handleDelete()}>
      <FaTrashAlt color="#eb506e" size={11} />
      <p>{text}</p>
    </DELETE_BUTTON>
  );
};
